import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  constructor(
    private http: HttpClient
  ) { }

  initializeWallet(userId: string): Observable<any>{
    return this.http.post(`${environment.apiUrl}/wallets/initialize`, {userId: userId})
  }



}
